import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    givenName: {
        label: "Prénom",
        optionsPlaceholder: "Charles"
    },
    familyName: {
        label: "Nom de famille",
        optionsPlaceholder: "Dupont"
    },
    gender: {
        label: "Sexe"
    },
    phoneNumber: {
        label: "Numéro de téléphone"
    },
    email: {
        label: "Adresse mail",
        optionsPlaceholder: "charles.dupont@nomdedomaine"
    },
    postalCode: {
        label: "Code Postal",
        optionsPlaceholder: "29200"
    },
    city: {
        label: "Ville",
        optionsPlaceholder: "Brest"
    },
    address: {
        label: "Adresse",
        optionsPlaceholder: "10 rue des Magnolias"
    },
    genderMale: {
        civility: { val: "M." },
        gender: { val: "M" }
    },
    genderFemale: {
        civility: { val: "Mme" },
        gender: { val: "F" }
    },
    civility: {
        label: "Civilité"
    },
    genderEmpty: {
        label: "Sélectionner"
    },
    birthDate: {
        label: "Date de naissance",
        optionsPlaceholder: "14/01/1971"
    },
    image: {
        label: "Ajouter une photo"
    },
    autoAccept: {
        label: "Accepter automatiquement"
    },
    advertisement: {
        label: "Annoncer sur Mon-APA"
    }
};

export type _I18nProfileBooking = typeof _fr;

const _en: _I18nProfileBooking = {
    givenName: {
        label: "Given name",
        optionsPlaceholder: "Charles"
    },
    familyName: {
        label: "Family name", optionsPlaceholder: "Dupont"
    },
    gender: {
        label: "Gender"
    },
    phoneNumber: {
        label: "Numéro de téléphone"
    },
    email: {
        label: "Email",
        optionsPlaceholder: "john.doe@domainname"
    },
    postalCode: {
        label: "Postal code",
        optionsPlaceholder: "29200"
    },
    city: {
        label: "City",
        optionsPlaceholder: "Brest"
    },
    address: {
        label: "Address",
        optionsPlaceholder: "10 rue des Magnolias"
    },
    genderMale: {
        civility: { val: "Mister" },
        gender: { val: "M" }
    },
    genderFemale: {
        civility: { val: "Miss" },
        gender: { val: "F" }
    },
    civility: {
        label: "Civility"
    },
    genderEmpty: {
        label: "Select"
    },
    birthDate: {
        label: "Birth date",
        optionsPlaceholder: "14/01/1971"
    },
    image: {
        label: "Add photo"
    },
    autoAccept: {
        label: "Auto accept booking"
    },
    advertisement: {
        label: "Advertise on Mon-APA"
    }
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18nProfileBooking(lang?: string): _I18nProfileBooking {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}